import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { format } from "date-fns";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";

const statusClass = (s) => s === "closed"
  ? "bg-emerald-500/20 text-emerald-300 border-emerald-500/30"
  : "bg-amber-500/20 text-amber-300 border-amber-500/30";

export default function ReferralEntriesList({ entries, onChange }) {
  const items = entries || [];

  const remove = async (e) => {
    if (!window.confirm(`Delete pending referral ${e.code}? This can't be undone.`)) return;
    try {
      await api.delete(`/referrals/${e.id}`);
      toast.success(`Referral ${e.code} deleted`);
      onChange?.();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed to delete");
    }
  };

  return (
    <div className="velo-card p-6">
      <h3 className="text-lg text-white font-medium">Your referral history</h3>
      <p className="text-xs text-slate-500 uppercase tracking-wider mt-1 mb-4">Each share creates a unique entry with its own code</p>
      <div className="space-y-2 max-h-96 overflow-y-auto">
        {items.map((e) => {
          const isPending = e.status === "pending";
          return (
            <div key={e.id} data-testid={`my-referral-${e.id}`} className="flex items-center justify-between p-4 velo-surface rounded-lg flex-wrap gap-3">
              <div className="flex-1 min-w-[200px]">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-mono text-sm text-white">{e.code}</span>
                  <Badge className={`text-xs border capitalize ${statusClass(e.status)}`}>{e.status}</Badge>
                </div>
                <div className="text-xs text-slate-500 mt-1">
                  Shared {format(new Date(e.created_at), "dd MMM yy, HH:mm")}
                  {e.service_name ? <span className="ml-2">· {e.service_name}</span> : null}
                </div>
              </div>
              <div className="flex items-center gap-3">
                {e.points_credited > 0 ? (
                  <div className="font-mono text-sm text-pink-400">+{e.points_credited} pts</div>
                ) : null}
                {isPending ? (
                  <Button data-testid={`btn-delete-referral-${e.id}`} onClick={() => remove(e)} size="sm" variant="ghost" className="text-slate-400 hover:text-red-400 hover:bg-red-500/10 rounded-full h-8">
                    <Trash2 className="w-3.5 h-3.5 mr-1.5" strokeWidth={1.5} /> Delete
                  </Button>
                ) : null}
              </div>
            </div>
          );
        })}
        {items.length === 0 ? <div className="text-slate-500 text-center py-8 text-sm">Share your code to create your first referral entry</div> : null}
      </div>
    </div>
  );
}
